class CouponCodeService {
	constructor(BaseService){
		'ngInject';
		this.BaseService = BaseService;
	}

	validateCouponCode(activationCode) {
		let params = {
			body: {
				couponCode : activationCode
			}
		};
		return this.BaseService.createPromise('validateCoupon', params);
	}
}

export default CouponCodeService;
